import { render, staticRenderFns } from "./features-privacy.vue?vue&type=template&id=1747bd0b&scoped=true"
import script from "./features-privacy.vue?vue&type=script&lang=js"
export * from "./features-privacy.vue?vue&type=script&lang=js"
import style0 from "./features-privacy.vue?vue&type=style&index=0&id=1747bd0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747bd0b",
  null
  
)

export default component.exports